'use strict';

// this stuff is not taken from rootGetters['situation/api/invitesAPI']
// import Api from '@/api/invite.js'
// --
import creation from '@/store/modules/invites/creation.js';
import { setFullName, setResponseComputedName } from '@/_helpers/utils.js';

const state = {
  loading: true,
  error: null,
  invites: [],
  selectedInvites: [],
  filters: {
    responseStatusId: null,
    vacancyId: null
  },
  sorting: {
    name: 'date',
    order: 'desc'
  },
  pagination: {
    pageNumber: 1,
    totalPages: 1,
    count: 20,
    load_more_pages: 1,
    is_load_more: false
  },
  filter: {
    name: '',
    email: '',
    phone: '',
    status_id: [],
    vacancy_id: [],
    date_created: [],
    user_id: [],
    query_filter: [],
    tag_id: []
  }
};

const actions = {
  load_more(context, is_active) {
    let params = {};
    let sorting = context.getters['sorting'];
    let pagination = context.getters['pagination'];
    let filters = context.getters['filters'];
    let filter_query = context.getters['filter_query'];

    if (sorting.name) {
      params['sort_by'] = sorting.name;
      params['sort_order'] = sorting.order;
    }
    if (filters.responseStatusId) {
      params = {
        ...params,
        response_status_id: filters.responseStatusId
      };
    }
    if (filters.vacancyId) {
      params = {
        ...params,
        vacancy_id: filters.vacancyId
      };
    }

    if (filter_query !== null) {
      params.filter = filter_query;
    }

    params.is_active = is_active;
    params.page = pagination.pageNumber + 1;
    params.count = pagination.count;

    return context.rootGetters['situation/api/invitesAPI'].fetch(params).then(r => {
      context.commit('add_to_list', r.data);
      context.commit('set_page', params.page);
    });
  },
  fetch({ commit, state, getters, dispatch, rootGetters }) {
    commit('fetch');
    console.log('dispatch invites fetch');
    const filters = state.filters;
    const sorting = state.sorting;

    let params = {};
    let filter_query = getters['filter_query'];

    if (state.filter.name) {
      params.name = state.filter.name;
    }

    if (state.filter.email) {
      params.email = state.filter.email;
    }

    if (state.filter.phone) {
      params.phone = state.filter.phone;
    }

    if (sorting.name) {
      params['sort_by'] = sorting.name;
      params['sort_order'] = sorting.order;
    }

    if (filters.responseStatusId) {
      params = {
        ...params,
        response_status_id: filters.responseStatusId
      };
    }

    if (filters.vacancyId) {
      params = {
        ...params,
        vacancy_id: filters.vacancyId
      };
    }

    let count = state.pagination.count;

    const is_load_more = state.pagination.is_load_more;

    if (is_load_more) {
      count = state.pagination.pageNumber * state.invites.length + state.pagination.count;

      params.page = 1;
      params.count = count;
    } else {
      params.page = state.pagination.pageNumber;
      params.count = state.pagination.count;
    }
    if (filter_query !== null) {
      params.filter = filter_query;
    }

    return rootGetters['situation/api/invitesAPI']
      .fetch(params)
      .then(({ data, meta }) => {
        commit('fetchSuccess', { data, meta, is_load_more });

        if (is_load_more) {
          commit('set_pagination_more', { count });
        }
        return data;
      })
      .catch(err => {
        dispatch('global/setError', err, { root: true });
        commit('fetchFailure', err);
      });
  },

  updateFilters({ commit, state, dispatch }, data) {
    commit('updateFilters', data);
    commit('updatePagination', {
      pageNumber: 1
    });

    dispatch('fetch');
  },

  updateSorting({ commit, state, dispatch }, data) {
    commit('updateSorting', data);

    dispatch('fetch');
  }
};

const mutations = {
  set_page(state, v) {
    state.pagination.pageNumber = v;
  },
  add_to_list(state, list) {
    let old_ids = state.invites.map(i => i.id);

    const newList = list.map(user => {
      if (!user.creator) {
        return user;
      }

      return Object.assign({}, user, {
        creator: setFullName(user.creator, 'first_name', 'last_name')
      });
    });
    newList.forEach(i => {
      // избегаем дублей
      if (old_ids.indexOf(i.id) === -1) {
        state.invites.push(i);
      }
    });
  },
  fetch(state) {
    state.loading = true;
  },

  fetchSuccess(state, { data, meta, is_load_more }) {
    if (!is_load_more) {
      state.pagination.totalPages = Math.ceil(meta.total / state.pagination.count);
    }

    const data_with_full_name = data.map(user => {
      if (!user.creator) {
        return user;
      }

      return Object.assign({}, user, {
        creator: setFullName(user.creator, 'first_name', 'last_name')
      });
    });
    state.invites = data_with_full_name.map(invite => setResponseComputedName(invite));
    state.loading = false;
  },

  fetchFailure(state, err) {
    state.error = err;
    state.loading = false;
    console.error(err);
  },

  updateFilters(state, data) {
    const filters = state.filters;

    Object.keys(data).forEach(key => {
      if (!filters.hasOwnProperty(key)) {
        throw new Error(`Unknown filter key ${key}`);
      }
    });

    Object.assign(state.filters, data);
  },

  updateSorting(state, data) {
    Object.assign(state.sorting, data);
  },

  updatePagination(state, params) {
    state.pagination = Object.assign(state.pagination, params);
  },

  set_load_more(state, val) {
    state.pagination = Object.assign(state.pagination, {
      is_load_more: val
    });
  },

  set_pagination_more(state, { count }) {
    state.pagination.load_more_pages = Math.ceil(count / state.pagination.count);
  },

  change_count(state, val) {
    state.pagination = Object.assign(state.pagination, {
      count: val,
      pageNumber: 1
    });
  },

  select(state, { model, value }) {
    const index = state.selectedInvites.findIndex(invite => invite.id === model.id);
    const exists = !!~index;

    if (value && !exists) {
      state.selectedInvites.push(model);
    } else if (!value && exists) {
      Vue.delete(state.selectedInvites, index);
    }
  },

  selectAll(state, value) {
    state.selectedInvites = [];

    if (value) {
      state.invites.forEach(response => state.selectedInvites.push(response));
    }
  },

  setFilter(state, val) {
    state.filter = val;
  },

  clear() {
    state.invites = [];
    state.selectedInvites = [];
  },

  set_filter(state, data) {
    state.filter[data.key] = data.v;
  } // key, v
};

const getters = {
  error(state) {
    return state.error;
  },

  loading(state) {
    return state.loading;
  },

  list(state) {
    return state.invites;
  },

  selectedList: (state, getters) => {
    return state.selectedInvites;
  },

  isSelected: (state, getters) => model => {
    return !!~state.selectedInvites.findIndex(invite => invite.id === model.id);
  },

  isSelectedAll: (state, getters) => {
    return state.selectedInvites.length === state.invites.length;
  },

  sorting: state => {
    return state.sorting;
  },

  filters: state => {
    return state.filters;
  },

  pagination: state => {
    return state.pagination;
  },

  filter: state => state.filter,

  filter_query(state) {
    let params = [];
    state.filter.query_filter.forEach(i => {
      let key, id;
      switch (i) {
        case 'status_id': {
          id = 'status_id';
          key = 'status_id';
          break;
        }
        case 'name': {
          id = 'name';
          key = 'name';
          break;
        }
        case 'email': {
          id = 'email';
          key = 'email';
          break;
        }
        case 'phone': {
          id = 'phone';
          key = 'phone';
          break;
        }
        case 'vacancy_id': {
          id = 'vacancy_id';
          key = 'vacancy_id';
          break;
        }
        case 'date_created': {
          id = 'date_created';
          key = 'date_created';
          break;
        }
        case 'user_id': {
          id = 'user_id';
          key = 'user_id';
          break;
        }
        case 'tag_id': {
          id = 'tag_id';
          key = 'tag_id';
          break;
        }
      }

      if (
        !!state.filter[key] &&
        state.filter[key].length > 0 &&
        typeof state.filter[key] == 'object'
      ) {
        params.push({ id, list: state.filter[key] });
      }
    });
    return params;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
  modules: {
    creation
  }
};
